import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	clearAll: {
		id: 'polaris-common.filters.clear.clear-all',
		defaultMessage: 'Clear all',
		description: 'Button caption for the clear all filters button',
	},
});
